// extracted by mini-css-extract-plugin
export default {"arrivals":"Arrivals_arrivals__zuxNW","header":"Arrivals_header__YCJED","cards":"Arrivals_cards__pD6xi","card":"Arrivals_card__N0RyO","textWrap":"Arrivals_textWrap__6Kiib"};